<template>
  <md-card class="md-card-profile">
    <div class="md-card-avatar">
      <md-icon class="md-size-4x">person</md-icon>
    </div>

    <md-card-content>
      <h6 class="category text-gray">{{ userRoleName }}</h6>
      <h4 class="card-title">{{ name }}</h4>
      <p class="card-description">{{ userRoleName }} CRM Discoveria</p>
      <md-button :to="{ name: 'logout' }" class="md-round md-danger"
        >Wyloguj mnie</md-button
      >
    </md-card-content>
  </md-card>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'user-card',
  props: {
    cardUserImage: {
      type: String,
      default: './img/faces/marc.jpg',
    },
    buttonColor: {
      type: String,
      default: '',
    },
  },
  data() {
    return {}
  },
  methods: {
    getColorButton: function(buttonColor) {
      return 'md-' + buttonColor + ''
    },
  },
  computed: {
    ...mapGetters(['userData', 'userRoleName']),
    name() {
      return `${this.userData.name} ${this.userData.surname}`
    },
  },
}
</script>
<style>
.md-card-avatar {
  background-color: #e2e0e0;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
